module.exports = __webpack_public_path__ + "img/info-block-icon.c26c86dd.svg";